import type { ReactNode, SVGProps } from "react";

export function TransactionsIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="12"
			viewBox="0 0 11 12"
			width="11"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M8.54688 0.625V11.125"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M4.28125 9.375L2.45312 11.125L0.625 9.375"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M2.45312 11.125V0.625"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M10.375 2.375L8.54688 0.625L6.71875 2.375"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
		</svg>
	);
}
